import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Prebooking.requests'
import {
    PreBookingEntity,
} from '../../PreBooking.types'

const useGetPreBooking = (id: number) => {
    return useRequest<PreBookingEntity>({
        key: RequestKeys.getPreBooking,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetPreBooking
